import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HeaderMessage from 'base/components/HeaderMessage';
import { getUsersById } from 'auth/store/users/selectors';
import { getTagsById } from 'documents/store/tags/selectors';
import { getFoldersById } from 'documents/store/folders/selectors';
import { setActiveDocumentId } from 'documents/store/documents/actions';
import { getSpacesById } from 'spaces/store/selectors';
import { isSafari } from 'utils/browser';
import { openModal } from '../../../modal';
import OfflineDocumentsList from '../../components/OfflineDocumentsList';
import { getOfflineDocuments, getOfflineDocumentIds } from '../../store/selectors';
import OfflineFileStore from '../../util/OfflineFileStore';
import { addOfflineStorageErrorId } from '../../store/actions';

class OfflineDocuments extends React.PureComponent {
  componentDidMount() {
    this.verifyStorage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ids !== this.props.ids) {
      this.verifyStorage();
    }
  }

  verifyStorage = () => {
    // Sanity check: ensure offline file store contains all keys saved for offline mode
    const { ids, addOfflineStorageErrorId } = this.props; // eslint-disable-line
    if (ids.length === 0) {
      return;
    }
    OfflineFileStore.keys()
      .then((storageIds) =>
        ids.forEach((id) => {
          if (storageIds.length < 1 || !storageIds.includes(id.toString())) {
            addOfflineStorageErrorId(id);
          }
        }))
      .catch(() => ids.forEach((id) => addOfflineStorageErrorId(id)));
  };

  handleDocumentView = (document) => {
    this.props.setActiveDocumentId(document.id);
    this.props.openModal('OFFLINE_DOCUMENT_VIEW');
  };

  render() {
    const {
      documents, usersById, tagsById, foldersById, spacesById,
    } = this.props;
    return (
      <>
        <HeaderMessage
          type="warning"
          title="You are offline"
          message={(
            <div>
                You can view and edit the documents below.
                Annotations made offline will be saved and synchronized automatically
                once you are back online
            </div>
)}
        />
        {isSafari() && (
        <HeaderMessage
          type="warning"
          title="Go online within the next 7 days to save your changes"
          message={(
            <div>
              Safari will only keep your offline changes
              for the next 7 days for data privacy reasons.
            </div>
          )}
        />
        )}
        <OfflineDocumentsList
          data={documents}
          usersById={usersById}
          tagsById={tagsById}
          foldersById={foldersById}
          spacesById={spacesById}
          onView={this.handleDocumentView}
        />
      </>
    );
  }
}
OfflineDocuments.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.number).isRequired,
  documents: PropTypes.arrayOf(PropTypes.object).isRequired,
  usersById: PropTypes.objectOf(PropTypes.any).isRequired,
  tagsById: PropTypes.objectOf(PropTypes.any).isRequired,
  foldersById: PropTypes.objectOf(PropTypes.any).isRequired,
  spacesById: PropTypes.objectOf(PropTypes.any).isRequired,
  setActiveDocumentId: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  addOfflineStorageErrorId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  ids: getOfflineDocumentIds(state),
  documents: getOfflineDocuments(state),
  usersById: getUsersById(state),
  tagsById: getTagsById(state),
  foldersById: getFoldersById(state),
  spacesById: getSpacesById(state),
});

const mapDispatchToProps = {
  setActiveDocumentId,
  openModal,
  addOfflineStorageErrorId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OfflineDocuments);
